import { configureStore } from '@reduxjs/toolkit'
import { ENV } from 'constants/envs'
import reducer from './slices'

const store = configureStore({
  reducer,
  devTools: ENV === 'development',
})

export type RootState = ReturnType<typeof reducer>
export type AppDispatch = typeof store.dispatch

export default store